import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { URL_CONST } from 'utils/urlConsts'

import toastActions from 'containers/Toasts/actions'

import Link from 'components/lib/DesignSystem/Link'

import FillSparkle from '../icons/FillSparkle'

const Container = styled.div`
  box-sizing: border-box;
  /* PopupMessage is max 415px with 30px padding; 400px overflowed and ate the left inset. */
  width: 340px;
  max-width: 100%;
  text-align: left;
`

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: var(--t-typography-font-size-sm);
  font-weight: var(--t-typography-font-weight-bold);
  color: var(--primary);
  margin-bottom: 8px;
`

const Description = styled.div`
  font-size: var(--t-typography-font-size-xs);
  color: var(--color-text);
  line-height: 1.5;
`

const TOAST_ID = 'send-simulations-success'

const ToastSuccessMessage = () => {
  const dispatch = useDispatch()

  return (
    <Container>
      <Title>
        <FillSparkle width="28px" height="28px" fill="var(--primary)" />
        Phishing Simulation Agent
      </Title>
      <Description>
        Launched successfully! Track progress in the{' '}
        <Link
          id="Psima_Dashboard_Success_Launched_Link"
          size={Link.SIZE.SMALL}
          href={URL_CONST.psima.launched}
          onClick={() => dispatch(toastActions.removeToast(TOAST_ID))}
        >
          Launched
        </Link>{' '}
        tab.
      </Description>
    </Container>
  )
}

export default ToastSuccessMessage
